export enum NgSeverityLevels {
  Error = 'error',
  Warn = 'warn',
  Info = 'info',
  Success = 'success'
}
